import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { ref, storage, query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, serverTimestamp, uploadBytesResumable, getDownloadURL } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // CSS bawaan te

const JadwalPembelajaran = () => {
    const [hari, sethari] = useState([]);
    const [rombel, setrombel] = useState([]);
    const [jadwal, setjadwal] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/getjadwalpembelajaran`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();

                sethari(data.hari);
                setrombel(data.rombel);
                setjadwal(data.jadwaldata)

            } catch (error) {
                Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
        };

        fetchData();
    }, []);
    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12"></div>
                        <div className="card">
                            <div className="card-body pc-component"></div>
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th width="10">Hari</th>
                                            <th width="20">Jam</th>
                                            {Array.isArray(rombel) &&
                                                rombel.map((rm, index) => (
                                                    <th key={index} width="20">{rm.nama_rombel}</th>
                                                ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(hari) &&
                                            hari
                                                .filter((datahari) => datahari.status === 'Aktif')
                                                .map((datahari, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr className="table-info">
                                                            {/* colSpan = 2 + jumlah rombel */}
                                                            <td colSpan={2 + (rombel ? rombel.length : 0)}><b>{datahari.nama}</b></td>
                                                        </tr>

                                                        {Array.isArray(datahari.list) && datahari.list.length > 0 ? (
                                                            datahari.list.map((item, idx) => (
                                                                <tr key={idx}>
                                                                    <td>{idx + 1}</td>
                                                                    <td>{item.jam_mulai.slice(0, 5)}</td>
                                                                    {Array.isArray(rombel) &&
                                                                        rombel.map((rm, i) => {
                                                                            // Cari jadwal yang sesuai rombel dan jam
                                                                            const jadwalItem = jadwal.find(
                                                                                (jdl) => jdl.rombel_id === rm.rombel_id && jdl.id_jam === item.id
                                                                            );
                                                                            return (
                                                                                <td key={i} width="20">
                                                                                    {jadwalItem ? (
                                                                                        <>
                                                                                            <h6><b>{jadwalItem.nama_guru}</b></h6>
                                                                                            <h6 className='text-muted'><i>{jadwalItem.initial}</i></h6>
                                                                                        </>
                                                                                    ) : (
                                                                                        '-'
                                                                                    )}
                                                                                </td>
                                                                            );
                                                                        })}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={2 + (rombel ? rombel.length : 0)} className="text-muted">
                                                                    Tidak ada data
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default JadwalPembelajaran;